export const API_URL: string =
  process.env.API_URL ??
  "https://persostack-ecomm-api-dot-gamma-15191-56.wl.r.appspot.com/api/products/";

export enum Endpoints {
  Product = "product_details",
  AllProduct = "all_product_details",
  Recommendation = "recommendation",
}

export const links = [
  {
    id: 1,
    text: "New",
    url: "/",
  },
  {
    id: 2,
    text: "Tops",
    url: "/tops",
  },
  {
    id: 3,
    text: "Bottoms",
    url: "/bottoms",
  },
  {
    id: 4,
    text: "Shoes",
    url: "/shoes",
  },
];

export const colorCodes = new Map([
  ["black", "#000000"],
  ["white", "#ffffff"],
  ["gray", "#D8D8D8"],
  ["blue", "#169DCD"],
  ["green", "#AFD874"],
  ["brown", "#A95B0C"],
  ["orange", "#E1A92F"],
  ["pink", "#DF8F8F"],
  ["purple", "#920CC1"],
  ["red", "#CD3030"],
  ["yellow", "#F9DF1F"],
]);

export const CategoryMenu = new Map([
  [
    "all",
    [
      { label: "Shoes", link: "/shoes" },
      { label: "Tops", link: "/tops" },
      { label: "Bottoms", link: "/bottoms" },
    ],
  ],
  [
    "tops",
    [
      { label: "T-Shirts", link: "/tops" },
      { label: "Long Sleeve Shirts", link: "/tops" },
      { label: "Sports Bras", link: "/tops" },
      { label: "Jackets", link: "/tops" },
      { label: "Sweatshirts", link: "/tops" },
    ],
  ],
  [
    "Bottoms",
    [
      { label: "Pants", link: "/bottoms" },
      { label: "Leggings", link: "/bottoms" },
      { label: "Shorts", link: "/bottoms" },
      { label: "Skirts", link: "/bottoms" },
    ],
  ],
  [
    "Shoes",
    [
      { label: "Lifestyle", link: "/shoes" },
      { label: "Running", link: "/shoes" },
      { label: "Basketball", link: "/shoes" },
      { label: "Training", link: "/shoes" },
      { label: "Skateboarding", link: "/shoes" },
    ],
  ],
]);
